<template>
  <div>
    <d-data-table
      ref="data-table"
      fluid
      resource="properties"
      searchable
      :loading="loading"
      :scrollable="true"
      :parameters="parameters"
      default-sort-field="status_availability_date"
      default-sort-order="asc"
      :edit-button="false"
      :delete-button="false"
      @search="onSearch"
      @pagination="OnPageChange"
    >
      <template #slide-filters>
        <div class="is-flex filters_container">
          <div class="w-full mr-4">
            <div class="field">
              <div class="control">
                <span class="select">
                  <select
                    v-model="parameters.filter.property_status"
                    name="property_status"
                    @change="onInputChange"
                  >
                    <option value="all">
                      {{ $t("all").capitalize() }}
                    </option>
                    <option :value="$laravel.STATUS_NOT_RENTED">
                      {{ $t("filter_not_rented").capitalize() }}
                    </option>
                    <option
                      v-for="status in $laravel.propertyStatuses"
                      :key="status"
                      :value="status"
                    >
                      {{ $t(status).capitalize() }}
                    </option>
                    <select />
                  </select>
                </span>
              </div>
            </div>
          </div>
          <!-- Filtres button on the right (the "En ligne seulement" switch
               lives inside the panel, last) -->
          <div class="filters-row">
            <v-sidebar-popup
            :action-label="$t('filters')"
            :count="filterCount"
            :action-type=" filterCount ? 'is-success' :'button'"
          >
            <template #header>
              <h2 class="is-size-5 has-text-weight-semibold">
                {{ $t("filters") }}
              </h2>
            </template>
            <v-form
              ref="form"
              :data="parameters.filter"
              url="#"
              :method="'post'"
            >
              <div class="">
                <div
                  v-if="
                    $roleCan([$laravel.role_admin]) ||
                      $laravel.user.is_owner_contact
                  "
                  class="column"
                >
                  <div class="field mb-1">
                    <label
                      class="label"
                      for="owners"
                    >
                      {{ $t("owners").capitalize() }}
                    </label>
                  </div>

                  <v-autocomplete-fetch
                    :value="owner"
                    clearable
                    :route="$laravel.route('api.owners.index')"
                    field="name"
                    :placeholder="$t('owner').capitalize()"
                    open-on-focus
                    @input="onOwnerChange($event)"
                  />
                </div>
                <div class="column">
                  <div class="field mb-1">
                    <label
                      class="label"
                      for="owner_business_id"
                    >
                      {{ $t("owner_businesses").capitalize() }}
                    </label>
                  </div>
                  <v-autocomplete-fetch
                    :value="ownerBusiness"
                    name="owner_business_id"
                    clearable
                    :route="$laravel.route('api.owner-businesses.properties')"
                    field="name"
                    :placeholder="$t('owner_businesses').capitalize()"
                    open-on-focus
                    @input="onOwnerBusinessChange($event)"
                  />
                </div>

                <div class="column">
                  <b-field>
                    <v-input-select
                      v-model="parameters.filter.type"
                      name="type"
                      :placeholder="$t('type')"
                      @input="setFilter('type', $event)"
                    >
                      <option value="">
                        {{ $t("all").capitalize() }}
                      </option>
                      <option
                        v-for="(type, key) in $laravel.propertyTypes"
                        :key="key"
                        :value="type"
                      >
                        {{ $t(type) }}
                      </option>
                    </v-input-select>
                  </b-field>
                </div>

                <div class="column">
                  <b-field>
                    <v-input-select
                      v-model="parameters.filter.occupation"
                      name="occupation"
                      :label="$t('occupation_label')"
                      @input="setFilter('occupation', $event)"
                    >
                      <option value="all">
                        {{ $t("all").capitalize() }}
                      </option>
                      <option value="vacant">
                        {{ $t("not_occupied") }}
                      </option>
                      <option value="occupied">
                        {{ $t("occupied") }}
                      </option>
                    </v-input-select>
                  </b-field>
                </div>

                <div
                  v-if="$roleCan([$laravel.role_admin])"
                  class="column"
                >
                  <div class="field mb-1">
                    <label
                      class="label"
                      for="rent_agent_id"
                    >
                      {{ $t("rent_agent_id").capitalize() }}
                    </label>
                  </div>
                  <v-autocomplete-fetch
                    :value="employee"
                    clearable
                    :route="$laravel.route('api.users.employees')"
                    field="name"
                    :placeholder="$t('rent_agent_id').capitalize()"
                    open-on-focus
                    :disabled="false"
                    @input="onEmployeeChange($event)"
                  />
                </div>
              </div>

              <div
                v-if="$roleCan([$laravel.role_admin])"
                class="column "
              >
                <b-switch
                  v-model="parameters.filter.not_assigned"
                  :true-value="true"
                  :false-value="null"
                  name="not_assigned"
                  @input="setFilter('not_assigned', $event)"
                >
                  {{ $t("not_assigned").capitalize() }}
                </b-switch>
              </div>

              <div class="">
                <div class="column price_filter">
                  <div class="field">
                    <label
                      class="label"
                      for="price"
                    >
                      {{ $t("price").capitalize() }}
                    </label>
                  </div>
                  <div class="is-flex">
                    <input
                      v-model="parameters.filter.price.min"
                      type="number"
                      class="input mr-1"
                      :placeholder="$t('min').capitalize()"
                      @input="onUpdatePriceFilter($event, 'min')"
                    >
                    <input
                      v-model="parameters.filter.price.max"
                      class="input"
                      type="number"
                      :placeholder="$t('max').capitalize()"
                      @input="onUpdatePriceFilter($event, 'max')"
                    >
                  </div>
                </div>
                <div class="column long_filter pt-0">
                  <b-switch
                    v-model="parameters.filter.long_property"
                    :true-value="true"
                    :false-value="null"
                    name="long_property"
                    @input="setFilter('long_property', $event)"
                  >
                    {{ $t("long_property").capitalize() }}
                  </b-switch>
                </div>
                <!-- Always shown (last), whatever the status filter -->
                <div class="column active_filter pt-0">
                  <b-switch
                    v-model="parameters.filter.active"
                    :true-value="true"
                    :false-value="false"
                    name="active"
                    @input="setFilter('active', $event)"
                  >
                    {{ $t("active_only").capitalize() }}
                  </b-switch>
                </div>
              </div>
            </v-form>
          </v-sidebar-popup>
          </div>
        </div>
      </template>
      <template #actions="{ row }">
        <!-- Mobile: new constat straight from the card (bottom-left) -->
        <button
          v-if="$mq === 'mobile' && row.latest_status"
          type="button"
          class="button is-small is-white work-shortcut"
          :title="$t('action_create_work')"
          @click="openConstat(row)"
        >
          <span class="work-emoji">🛠️</span>
        </button>
        <!-- Certificat bon état: shown only once Devloc certified the unit,
             beside the online dot; hover for the details -->
        <b-tooltip
          v-if="row.latest_status && row.latest_status.devloc_good_condition"
          type="is-black"
          :position="$mq === 'mobile' ? 'is-top' : 'is-left'"
          multilined
          append-to-body
        >
          <span class="button is-small is-white cert-badge">
            <i class="mdi mdi-check-decagram mdi-18px" />
          </span>
          <template #content>
            <div class="has-text-left">
              <p class="has-text-weight-semibold mb-1">
                {{ $t("good_condition_cert_tooltip_title") }}
              </p>
              <p>{{ certLine("devloc", row.latest_status) }}</p>
              <p>{{ certLine("client", row.latest_status) }}</p>
            </div>
          </template>
        </b-tooltip>

        <v-activate-property-status
          :property-status="row.latest_status"
          @success="onSuccessActivatePropertyStatusForRent"
        />

        <button
          v-if="row.latest_status && $roleCan([$laravel.role_admin])"
          class="button is-small is-white"
          type="button"
          @click="togglePublicVisibility(row.latest_status)"
        >
          <div
            class="icon"
            :class="{
              'has-text-success': row.latest_status.publicly_visible,
              'has-text-danger': !row.latest_status.publicly_visible,
            }"
          >
            <i
              class="mdi mdi-18px"
              :class="{
                'mdi-eye-outline': row.latest_status.publicly_visible,
                'mdi-eye-off-outline': !row.latest_status.publicly_visible,
              }"
            />
          </div>
        </button>

        <!-- Less frequent actions grouped under "…": change status,
             duplicate, settings page, delete -->
        <b-dropdown
          position="is-bottom-left"
          append-to-body
          aria-role="list"
        >
          <template #trigger>
            <button
              class="button is-small is-white"
              type="button"
            >
              <div class="icon has-text-grey">
                <i class="mdi mdi-dots-horizontal mdi-18px" />
              </div>
            </button>
          </template>

          <b-dropdown-item
            v-if="row.latest_status"
            aria-role="listitem"
            @click="openModal(row)"
          >
            <span class="icon-text">
              <span class="icon has-text-grey"><i class="mdi mdi-circle-edit-outline" /></span>
              <span>{{ $t("modal_status_update_in_property_list") }}</span>
            </span>
          </b-dropdown-item>

          <b-dropdown-item
            v-if="row.latest_status && $mq !== 'mobile'"
            aria-role="listitem"
            @click="openConstat(row)"
          >
            <span class="icon-text">
              <span class="icon has-text-grey"><i class="mdi mdi-tools" /></span>
              <span>{{ $t("action_create_work") }}</span>
            </span>
          </b-dropdown-item>

          <b-dropdown-item
            v-if="$laravel.user.permissions.property.duplicate"
            aria-role="listitem"
            @click="openDuplicatePropertyModal(row)"
          >
            <span class="icon-text">
              <span class="icon has-text-grey"><i class="mdi mdi-content-duplicate" /></span>
              <span>{{ $t("action_duplicate") }}</span>
            </span>
          </b-dropdown-item>

          <b-dropdown-item
            aria-role="listitem"
            :disabled="!(row.can && row.can.update)"
            @click="$router.push(createEditPropertyLink(row))"
          >
            <span class="icon-text">
              <span class="icon has-text-grey"><i class="mdi mdi-cog" /></span>
              <span>{{ $t("action_configure") }}</span>
            </span>
          </b-dropdown-item>

          <b-dropdown-item
            v-if="row.can && Object.prototype.hasOwnProperty.call(row.can, 'delete')"
            aria-role="listitem"
            class="has-text-danger"
            @click="showDeletePropertyModal(row)"
          >
            <span class="icon-text">
              <span class="icon"><i class="mdi mdi-delete" /></span>
              <span>{{ $t("delete").capitalize() }}</span>
            </span>
          </b-dropdown-item>
        </b-dropdown>
      </template>

      <b-table-column
        v-slot="props"
        field="address"
        :label="$t('address').capitalize()"
        sortable
      >
        <div class="is-flex">
          <b-tooltip
            type="is-black"
            position="is-right"
            multilined
          >
            <router-link
              :to="createEditPropertyLink(props.row)"
              class="has-text-info has-text-weight-semibold is-size-7"
            >
              {{ props.row.address.full_address }}
            </router-link>

            <template #content>
              <div>
                <p>
                  {{ $t("owner").capitalize() + ": " + props.row.owner.name }}
                </p>
                <p>
                  {{ $t("owner_businesses").capitalize() + ": " }}
                  <span v-if="props.row.owner_business">
                    {{ props.row.owner_business.name }}
                  </span>
                  <span v-else> - </span>
                </p>
              </div>
            </template>
          </b-tooltip>
        </div>
      </b-table-column>

      <b-table-column
        v-slot="props"
        field="unit"
        :label="$t('address_2').capitalize()"
        sortable
      >
        <div class="is-flex">
          <div class="is-size-7">
            {{ props.row.address.address_2 }}
          </div>
        </div>
      </b-table-column>

      <b-table-column
        v-slot="props"
        field="property_status_latest_type"
        :label="$t('status').capitalize()"
        sortable
      >
        <div class="is-size-7">
          <div
            v-if="props.row.property_status_latest_type"
            class="status-pill"
            :class="[statusTagClass(props.row), { 'is-clickable': props.row.latest_status }]"
            :title="props.row.latest_status ? $t('modal_status_update_in_property_list') : null"
            @click="props.row.latest_status && openModal(props.row)"
          >
            {{ statusShortLabel(props.row) }}
          </div>
        </div>
      </b-table-column>

      <b-table-column
        v-slot="props"
        field="type"
        :label="$t('housing_size').capitalize()"
        sortable
      >
        <div class="is-size-7">
          {{ $t(props.row.type) }}
        </div>
      </b-table-column>

      <b-table-column
        v-slot="props"
        field="property_status_asked_rent"
        :label="$t('asked_rent').capitalize()"
        sortable
      >
        <div
          v-if="props.row.property_status_asked_rent"
          class="is-size-7"
        >
          <a
            v-if="props.row.latest_status && props.row.can && props.row.can.update"
            class="rent-edit-link"
            @click="openRentModal(props.row)"
          >
            {{ props.row.property_status_asked_rent }}$
          </a>
          <span v-else>{{ props.row.property_status_asked_rent }}$</span>
        </div>
      </b-table-column>

      <!-- Promotion at a glance; hover for the details -->
      <b-table-column
        v-slot="props"
        field="promotion"
        :label="$t('promo_short')"
        sortable
      >
        <span
          v-if="props.row.latest_status && props.row.latest_status.promotion_type && $mq === 'mobile'"
          class="is-size-6 is-clickable"
          @click="showPromotion(props.row.latest_status)"
        >📢</span>
        <b-tooltip
          v-else-if="props.row.latest_status && props.row.latest_status.promotion_type"
          type="is-black"
          position="is-left"
          append-to-body
          multilined
          :label="promotionTooltip(props.row.latest_status)"
        >
          <span class="is-size-6">📢</span>
        </b-tooltip>
      </b-table-column>

      <b-table-column
        v-slot="props"
        field="status_availability_date"
        :label="$t('availability_date_show').capitalize()"
        sortable
      >
        <div
          v-if="props.row.latest_status"
          class="is-size-7 no-wrap-text"
        >
          <span v-if="props.row.availability_date">
            {{ $shortDate(props.row.latest_status.availability_date) }}
          </span>
        </div>
      </b-table-column>

      <!-- Occupation: Vacant / Occupé -->
      <b-table-column
        v-slot="props"
        field="occupation"
        :label="$t('occupation_label')"
        sortable
      >
        <div
          v-if="props.row.latest_status"
          class="is-size-7"
        >
          <span
            class="status-pill"
            :class="isOccupied(props.row.latest_status) ? 'is-occupied' : 'is-vacant'"
          >
            {{ isOccupied(props.row.latest_status) ? $t("occupied") : $t("not_occupied") }}
          </span>
        </div>
      </b-table-column>

      <b-table-column
        v-slot="props"
        field="rent_agent_name"
        :label="$t('rent_agent_name').capitalize()"
      >
        <div
          v-if="props.row.latest_status"
          class="is-flex gap-1 is-justify-content-space-between"
        >
          <!-- Stacked avatars (first 3 overlap, grey "+N" bubble for the
               rest, names on hover). Admins click the pile — or the empty
               placeholder — to edit the agents; no separate pencil -->
          <div
            class="agent-pile"
            :class="{ 'is-editable': $roleCan([$laravel.role_admin]) }"
            @click="$roleCan([$laravel.role_admin]) && showRentAgentPopup(props.row)"
          >
            <template v-if="props.row.latest_status.rent_agents && props.row.latest_status.rent_agents.length">
              <span
                v-for="rent_agent in props.row.latest_status.rent_agents.slice(0, 3)"
                :key="rent_agent.id"
              >
                <b-tooltip
                  type="is-black"
                  position="is-right"
                  multilined
                >
                  <img
                    class="is-30 is-avatar"
                    :src="rent_agent.avatar_url"
                  >

                  <template #content>
                    <div>
                      <p>
                        {{ rent_agent.name }}
                      </p>
                      <p>
                        {{ rent_agent.email }}
                      </p>
                    </div>
                  </template>
                </b-tooltip>
              </span>
              <span v-if="props.row.latest_status.rent_agents.length > 3">
                <b-tooltip
                  type="is-black"
                  position="is-right"
                  multilined
                >
                  <span class="is-30 agent-more">
                    +{{ props.row.latest_status.rent_agents.length - 3 }}
                  </span>

                  <template #content>
                    <div>
                      <p
                        v-for="rent_agent in props.row.latest_status.rent_agents.slice(3)"
                        :key="rent_agent.id"
                      >
                        {{ rent_agent.name }}
                      </p>
                    </div>
                  </template>
                </b-tooltip>
              </span>
            </template>
            <!-- No agent yet: grey placeholder avatar (click to assign) -->
            <span
              v-else-if="$roleCan([$laravel.role_admin])"
              class="is-30 agent-more agent-empty"
              :title="$t('rent_agent_name').capitalize()"
            >
              <i class="mdi mdi-account-plus" />
            </span>
            <span v-else> - </span>
          </div>
        </div>
      </b-table-column>
    </d-data-table>

    <!-- New constat (Travaux et inspection) for a unit, from the card / "…" menu -->
    <v-constat-form
      :active="isConstatOpen"
      :property-id="constatPropertyId"
      @close="isConstatOpen = false"
      @saved="reloadDataTable"
    />

    <!-- Quick rent edit, same endpoint as the details-page pencil -->
    <b-modal
      v-model="isRentModalOpen"
      :width="420"
    >
      <div
        v-if="rentEditRow"
        class="modal-card"
      >
        <header class="modal-card-head">
          <p class="modal-card-title title is-6 mb-0">
            {{ $t("asked_rent").capitalize() }} — {{ rentEditRow.full_address_with_unity }}
          </p>
          <button
            class="delete"
            aria-label="close"
            @click="isRentModalOpen = false"
          />
        </header>
        <section class="modal-card-body">
          <b-field :label="$t('asked_rent').capitalize()">
            <b-input
              v-model="rentEditValue"
              type="number"
              min="0"
              step="1"
            />
          </b-field>
          <footer class="mt-4 has-text-right">
            <b-button
              :label="$t('cancel').capitalize()"
              @click="isRentModalOpen = false"
            />
            <b-button
              type="is-primary"
              :loading="rentSaving"
              :disabled="!rentEditValue"
              @click="saveRent"
            >
              {{ $t("save") }}
            </b-button>
          </footer>
        </section>
      </div>
    </b-modal>

    <b-modal
      v-model="isShowDuplicatePropertyModal"
      :width="600"
      @success="reloadDataTable"
      @close="closeDuplicateModal"
    >
      <div class="modal-card">
        <header
          class="modal-card-head is-flex-direction-column is-flex is-align-items-flex-start"
        >
          <div
            class="is-flex is-full is-align-content-space-between"
            style="width: 100%"
          >
            <p class="modal-card-title title mb-0">
              {{ $t("duplicate_property_title") }}
            </p>
            <button
              class="delete"
              aria-label="close"
              @click="closeDuplicateModal"
            />
          </div>
        </header>

        <section class="modal-card-body">
          <v-duplicate-form
            v-if="duplicatePropertyObject != null"
            :property="duplicatePropertyObject"
            @success="successDuplicateProperty"
            @close="closeDuplicateModal"
          />
        </section>
      </div>
    </b-modal>
    <b-modal
      v-model="is_show"
      v-bind="modalPropertyStatus"
      :width="600"
      @close="closeModal"
    >
      <div class="modal-card">
        <header
          class="modal-card-head is-flex-direction-column is-flex is-align-items-flex-start"
        >
          <div
            class="is-flex is-full is-align-content-space-between"
            style="width: 100%"
          >
            <p class="modal-card-title title mb-2">
              {{ $t("modal_status_update_in_property_list") }}
            </p>
            <button
              class="delete"
              aria-label="close"
              @click="closeModal"
            />
          </div>
          <div class="modal-card-subtitle">
            <p class="is-size-7">
              {{ $t("modal_message_first_part") }}
              {{ $shortStreet(modalPropertyStatus.property.address.address_1) }}
              {{ modalPropertyStatus.property.address.address_2 }}
              ({{ modalPropertyStatus.property.address.city }})
              {{ $t("modal_message_second_part") }}
              <span class="has-text-weight-bold">
                {{ $t(currentPropertyStatus) }}
              </span>
              <span v-if="newPropertyStatus">
                {{ $t("modal_message_third_part") }}
                {{ $t("from") }}
                <span class="has-text-weight-bold">
                  {{ $t(currentPropertyStatus) }}
                </span>
                {{ $t("to") }}
                <span class="has-text-weight-bold">
                  {{ $t(newPropertyStatus) }}
                </span>
                {{ $t("modal_message_forth_part") }}
              </span>
            </p>
          </div>
        </header>
        <section class="modal-card-body">
          <v-popup-form
            :property="modalPropertyStatus.property"
            @success="reloadDataTable"
            @close="closeModal"
            @status="updateNewStatus"
          />
        </section>
      </div>
    </b-modal>
    <b-modal
      :active="currentlyEditedRendAgentPropertyId != null"
      :width="600"
      @close="onRentAgentModelClose()"
    >
      <div class="box">
        <v-form
          v-if="currentlyEditedRendAgentPropertyId"
          :data="formRentAgent"
          method="patch"
          :url="
            $laravel.route('api.property.update.rent_agent', {
              property: currentlyEditedRendAgentPropertyId,
            })
          "
          @success="onSuccessRentAgentModel"
        >
          <v-input-tag-fetch
            :value="rent_agents"
            name="rent_agent_id"
            :route="$laravel.route('api.users.employees')"
            :placeholder="$t('rent_agent_id').capitalize()"
            :label="$t('rent_agent_id').capitalize()"
            :open-on-focus="true"
            field="name"
            @input="onRentAgentsModelChange($event)"
          />

          <v-input
            v-model="formRentAgent.agent_commission_fee"
            type="number"
            name="agent_commission_fee"
          />

          <v-input
            v-model="formRentAgent.google_drive_url_link"
            type="text"
            name="google_drive_url_link"
          />

          <v-input-rich-text
            v-model="formRentAgent.internal_notes"
            name="internal_notes"
          />

          <button
            type="submit"
            class="button is-primary"
          >
            {{ $t("update") }}
          </button>
        </v-form>
      </div>
    </b-modal>

    <b-modal
      v-model="isShownDeletePropertyModal"
      :width="600"
      @close="closeDeletePropertyModal"
    >
      <div
        class="modal-card"
        style="width: auto"
      >
        <header class="modal-card-head">
          <p class="modal-card-title">
            {{ $t("delete_property_title") }}
          </p>
        </header>
        <section class="modal-card-body">
          <p class="mb-1">
            {{ $t("delete_property_message_line_1") }}
          </p>
          <p class="mb-3">
            {{ $t("delete_property_message_line_2") }}
          </p>
          <p class="mb-3">
            {{ $t("delete_property_message_line_3") }}
          </p>
          <p class="mb-3">
            {{ $t("delete_property_message_line_4") }}
          </p>
          <p class="mb-1">
            {{ $t("delete_property_message_line_5") }}
          </p>
          <div class="is-fullwidth mt-4">
            <b-checkbox v-model="isAcceptedDeleteCondition">
              <span class="has-text-weight-medium">
                {{ $t("delete_property_btn_confirm_checkbox") }}
              </span>
            </b-checkbox>
          </div>
        </section>
        <footer class="modal-card-foot is-justify-content-flex-end">
          <b-button
            :label="$t('cancel')"
            @click="closeDeletePropertyModal"
          />
          <button
            class="button is-danger"
            :disabled="!isAcceptedDeleteCondition"
            type="button"
            @click="confirmDeleteProperty"
          >
            {{ $t("delete_property_btn_confirm") }}
          </button>
        </footer>
      </div>
    </b-modal>
  </div>
</template>

<script>
import AutocompleteFetchVue from "@/plugins/form/components/AutocompleteFetch.vue";
import form_popup from "./_form_popup.vue";
import notificator from "@/services/notificator";

import modal_duplicate from "./_modal_duplicate.vue";

import ActivateForRentStatusComponent from "./components/ActivateForRentStatusComponent.vue";
import SideBarModalComponent from "./components/SideBarModalComponent.vue";
import ConstatFormModal from "../propertyInspection/components/ConstatFormModal.vue";

import DataTableFilters from "@/shared/mixins/DataTableFilters";

export default {
  components: {
    "v-autocomplete-fetch": AutocompleteFetchVue,
    "v-popup-form": form_popup,
    "v-duplicate-form": modal_duplicate,
    "v-activate-property-status": ActivateForRentStatusComponent,
    "v-sidebar-popup": SideBarModalComponent,
    "v-constat-form": ConstatFormModal,
  },
  mixins: [DataTableFilters],
  data() {
    return {
      filterKey: "property_list",
      isShowDuplicatePropertyModal: false,
      loading: false,
      is_show: false,
      employee: null,
      owner: null,
      ownerBusiness: null,
      duplicatePropertyObject: null,
      isConstatOpen: false,
      constatPropertyId: null,
      isRentModalOpen: false,
      rentEditRow: null,
      rentEditValue: null,
      rentSaving: false,
      propertyStatuses: [],
      currentPropertyStatus: "",
      newPropertyStatus: "",
      modalPropertyStatus: {
        property: {
          id: "",
          property_status_latest_type: "",
          address: {
            address_1: "",
            address_2: "",
            city: "",
          },
        },
      },
      parameters: {
        filter: {
          type: "",
          property_status: this.$laravel.STATUS_NOT_RENTED,
          owner_id: null,
          owner_business_id: null,
          active: false,
          not_assigned: false,
          occupation: "all",
          long_property: null,
          rent_agent_id: null,
          price: {
            min: null,
            max: null,
          },
          availability_date: [],
        },
        search: "",
        page: 1,
      },
      currentlyEditedRendAgentPropertyId: null,
      formRentAgent: {
        rent_agent: null,
        rent_agent_id: null,
        agent_commission_fee: null,
        google_drive_url_link: null,
        internal_notes: null,
        rent_agent_ids: [],
      },
      rent_agents: [],
      isShownDeletePropertyModal: false,
      isAcceptedDeleteCondition: false,
      currentPropertyReadyForDelete: null,
    };
  },
  computed: {
    filterCount() {
      let count = 0;

      if (this.parameters.filter.type && this.parameters.filter.type != "") {
        count = count + 1;
      }

      if (this.parameters.filter.owner_id) {
        count = count + 1;
      }

      if (this.parameters.filter.owner_business_id) {
        count = count + 1;
      }

      if (this.parameters.filter.active) {
        count = count + 1;
      }

      if (this.parameters.filter.long_property) {
        count = count + 1;
      }

      if (this.parameters.filter.rent_agent_id) {
        count = count + 1;
      }

      if (this.parameters.filter.price.min) {
        count = count + 1;
      }

      if (this.parameters.filter.price.max) {
        count = count + 1;
      }

      if (this.parameters.filter.not_assigned) {
        count = count + 1;
      }

      if (this.parameters.filter.occupation && this.parameters.filter.occupation !== "all") {
        count = count + 1;
      }

      return count;
    },
    dataTableParameters() {
      const params = this.$refs["data-table"].allParameters;

      if (!params) {
        return {};
      }

      return params;
    },
  },
  created() {
    const filters = this.getFilters();

    const newParameters = _.cloneDeep(this.parameters);

    filters.forEach((filter) => {
      if (filter.key == "search") {
        newParameters.search = filter.value;
      }

      if (filter.key == "min" || filter.key == "max") {
        newParameters.filter.price[filter.key] = filter.value;
      }

      if (newParameters.filter[filter.key] !== undefined) {
        if (filter.key == "min" || filter.key == "max") {
          return;
        }

        if (filter.key == "owner_id") {
          this.owner = {
            id: filter.value,
            name: filter.label,
          };
        }

        if (filter.key == "owner_business_id") {
          this.ownerBusiness = {
            id: filter.value,
            name: filter.label,
          };
        }

        if (filter.key == "rent_agent_id") {
          this.employee = {
            id: filter.value,
            name: filter.label,
          };
        }

        newParameters.filter[filter.key] = filter.value;
      }

      if (filter.key == "not_assigned") {
        newParameters.filter.not_assigned = filter.value;
      }

      if (filter.key == "page") {
        newParameters.page = filter.value;
      }
    });

    this.parameters = newParameters;
  },
  methods: {
    showDeletePropertyModal(row) {
      this.currentPropertyReadyForDelete = row;
      this.isShownDeletePropertyModal = true;
    },
    closeDeletePropertyModal() {
      this.currentPropertyReadyForDelete = null;
      this.isShownDeletePropertyModal = false;
      this.isAcceptedDeleteCondition = false;
    },
    confirmDeleteProperty() {
      if (!this.isAcceptedDeleteCondition) {
        return;
      }

      this.$http
        .delete(
          this.$laravel.route("api.properties.destroy", {
            property: this.currentPropertyReadyForDelete.id,
          })
        )
        .then((response) => {
          this.closeDeletePropertyModal();
          this.$refs["data-table"].loadData();
          notificator.open({
            message: response.data.message,
            type: "success",
          });
        })
        .catch((e) => {
          console.error(e);
        });
    },
    onSearch(keywords) {
      this.setFilter("search", keywords);

      this.setFilter("page", 1);
    },
    OnPageChange(page) {
      if (!page) {
        page = 1;
      }

      this.setFilter("page", page);
    },
    createEditPropertyLink(property) {
      if (property.latest_status) {
        return `/properties/${property.id}/details`;
      }
      return `/properties/create/${property.id}/status`;
    },
    onInputChange(event) {
      const value = event?.target?.value;

      if (value == this.$laravel.STATUS_FOR_RENT) {
        this.parameters.filter.active = false;
        this.setFilter("active", false);
      } else {
        this.parameters.filter.active = false;
        this.setFilter("active", false);
      }

      this.setFilter("property_status", value);
    },
    showRentAgentPopup(row) {
      this.currentlyEditedRendAgentPropertyId = row.id;
      this.formRentAgent.google_drive_url_link =
        row.latest_status.google_drive_url_link;
      this.formRentAgent.agent_commission_fee =
        row.latest_status.agent_commission_fee;
      this.formRentAgent.internal_notes = row.latest_status.internal_notes;

      if (
        row.latest_status.rent_agents &&
        row.latest_status.rent_agents.length
      ) {
        this.rent_agents = row.latest_status.rent_agents;
        this.formRentAgent.rent_agent_ids = row.latest_status.rent_agents.map(
          (item) => item.id
        );
      }
    },
    // Good-condition certifications: red none, yellow partial, green both
    // "Client : 12 septembre 2026 14:30" / "Devloc : Non"
    certLine(who, status) {
      const label = who === "client" ? "Client" : "Devloc";
      const certified = !!status[who + "_good_condition"];
      const at = status[who + "_good_condition_at"];

      if (!certified) {
        return label + " : " + this.$t("no").capitalize();
      }

      return label + " : " + (at ? this.$dayjs(at).format("LL") : this.$t("yes").capitalize());
    },
    // Status pill modifier (.status-pill in admin.scss, shared with the
    // details page): green = À louer, amber = Application, blue = Loué,
    // red = Rénovation / Attente
    statusTagClass(row) {
      const type = row.property_status_latest_type;

      if (type === "in_renovation") {
        const sub = row.latest_status && row.latest_status.in_renovation_status;
        return sub === "pending" ? "is-pending" : "is-in-renovation";
      }

      return { for_rent: "is-for-rent", in_application: "is-in-application", rented: "is-rented" }[type] || "";
    },
    // One-word labels for the list: Rénovation / Attente / À louer / Loué /
    // Application (the long forms stay on the detail pages)
    statusShortLabel(row) {
      const type = row.property_status_latest_type;

      if (type === "in_renovation") {
        const sub = row.latest_status && row.latest_status.in_renovation_status;
        return this.$t(sub === "pending" ? "status_short_pending" : "status_short_in_renovation");
      }

      return this.$t("status_short_" + type);
    },
    // Vacant / Occupé: the answer given in the status form, else whether a
    // current tenant is on file (same rule as the details page)
    isOccupied(status) {
      if (status.is_occupied === true || status.is_occupied === false) {
        return status.is_occupied;
      }

      return !!status.is_property_occupied;
    },
    showPromotion(status) {
      this.$buefy.dialog.alert({
        title: this.$t("promotion").capitalize(),
        message: this.promotionTooltip(status),
        confirmText: this.$t("close"),
      });
    },
    promotionTooltip(status) {
      if (status.promotion_type === "monthly_credit") {
        let text =
          this.$t("promotion_type_credit") + " : " + status.promotion_credit_amount + "$";

        if (status.asked_rent) {
          const promo = Math.max(
            0,
            parseFloat(status.asked_rent) - parseFloat(status.promotion_credit_amount)
          );

          text += " → " + promo + "$/" + this.$t("month_short");
        }

        return text;
      }
      if (status.promotion_type === "free_month") {
        return (
          this.$t("promotion_type_free_month") +
          " (" +
          this.$t("promotion_month_" + status.promotion_free_month) +
          ")"
        );
      }

      return status.promotion_text || this.$t("promotion").capitalize();
    },
    openConstat(row) {
      this.constatPropertyId = row.id;
      this.isConstatOpen = true;
    },
    openRentModal(row) {
      this.rentEditRow = row;
      this.rentEditValue = row.property_status_asked_rent;
      this.isRentModalOpen = true;
    },
    saveRent() {
      this.rentSaving = true;
      this.$http
        .patch(
          this.$laravel.route("api.property.statuses.update_field_details", {
            property: this.rentEditRow.id,
            field: "asked_rent",
          }),
          { asked_rent: this.rentEditValue }
        )
        .then((response) => {
          this.isRentModalOpen = false;
          this.$refs["data-table"].loadData();
          notificator.open({
            message: response.data.message,
            type: "success",
          });
        })
        .catch((e) => {
          console.error(e);
        })
        .finally(() => {
          this.rentSaving = false;
        });
    },
    togglePublicVisibility(latestStatus) {
      this.$buefy.dialog.confirm({
        title: this.$t("confirm_public_visibility_title"),
        message: this.$t(
          latestStatus.publicly_visible
            ? "confirm_public_visibility_not_visible_description"
            : "confirm_public_visibility_visible_description"
        ),
        confirmText: this.$t("confirm"),
        cancelText: this.$t("cancel"),
        type: latestStatus.publicly_visible ? "is-danger" : "is-success",
        onConfirm: () => {
          this.$http
            .patch(
              this.$laravel.route("api.property.statuses.public_visibility", {
                property: latestStatus.property_id,
                propertyStatus: latestStatus.id,
              })
            )
            .then((response) => {
              this.loading = false;
              this.$refs["data-table"].loadData();
              notificator.open({
                message: response.data.message,
                type: "success",
              });
            })
            .catch((e) => {
              console.error(e);
            });
        },
      });
    },
    successDuplicateProperty(payload) {
      this.duplicatePropertyObject = null;
      this.isShowDuplicatePropertyModal = false;

      this.$router.push(
        `/properties/create/${payload.data.property.id}/status`
      );
    },
    closeDuplicateModal() {
      this.duplicatePropertyObject = null;
      this.isShowDuplicatePropertyModal = false;
    },
    openDuplicatePropertyModal(row) {
      this.duplicatePropertyObject = row;
      this.isShowDuplicatePropertyModal = true;
    },
    updateNewStatus(newPropertyStatus) {
      this.newPropertyStatus = newPropertyStatus;
    },
    openModal(property) {
      this.modalPropertyStatus = property.latest_status ?? {};
      this.modalPropertyStatus.property = { ...property };
      this.currentPropertyStatus = property.latest_status
        ? property.latest_status.type
        : "";
      this.modalPropertyStatus.property_id = property.id;
      this.is_show = true;
    },
    closeModal() {
      this.is_show = false;
    },
    reloadDataTable() {
      this.is_show = false;
      this.modalPropertyStatus.type = "";
      this.$refs["data-table"].loadData();
    },
    onOwnerChange(owner) {
      if (owner && owner.id) {
        this.parameters.filter.owner_id = owner.id;
        this.setFilter("owner_id", owner.id, owner.name);
      } else {
        this.parameters.filter.owner_id = null;
        this.owner = null;
        this.setFilter("owner_id", null);
      }
    },
    onOwnerBusinessChange(ownerBusiness) {
      if (ownerBusiness && ownerBusiness.id) {
        this.parameters.filter.owner_business_id = ownerBusiness.id;
        this.setFilter(
          "owner_business_id",
          ownerBusiness.id,
          ownerBusiness.name
        );
      } else {
        this.parameters.filter.owner_business_id = null;
        this.setFilter("owner_business_id", null);
        this.ownerBusiness = null;
      }
    },
    onEmployeeChange(value) {
      if (value && value.id) {
        this.parameters.filter.rent_agent_id = value.id;
        this.setFilter("rent_agent_id", value.id, value.name);
      } else {
        this.parameters.filter.rent_agent_id = null;
        this.setFilter("rent_agent_id", null);
        this.employee = null;
      }
    },
    onUpdatePriceFilter(event, key) {
      this.setFilter(key, this.parameters.filter.price[key]);
    },
    onRentAgentsModelChange(value) {
      if (value && value.length) {
        this.formRentAgent.rent_agent_ids = value.map((item) => item.id);
        this.rent_agents = value;
      } else {
        this.formRentAgent.rent_agent_ids = [];
        this.rent_agents = [];
      }
    },
    onRentAgentModelClose() {
      this.currentlyEditedRendAgentPropertyId = null;
      this.formRentAgent.agent_commission_fee = null;
      this.formRentAgent.google_drive_url_link = null;
      this.formRentAgent.internal_notes = null;
      this.formRentAgent.rent_agent_ids = [];
      this.rent_agents = [];
    },
    onSuccessRentAgentModel() {
      this.$refs["data-table"].loadData();
      this.onRentAgentModelClose();
    },
    onSuccessActivatePropertyStatusForRent() {
      this.$refs["data-table"].loadData();
    },
  },
};
</script>

<style scoped>
.custom-tooltip-position .b-tooltip.is-top .tooltip-content {
  transform: none !important;
}
/* Mobile card: the 🛠️ shortcut sits at the far left of the actions row */
.work-shortcut {
  margin-right: auto;
}
.work-emoji {
  font-size: 17px;
  line-height: 1;
}
.no-wrap-text {
  white-space: nowrap;
}
.status-pill.is-clickable {
  cursor: pointer;
}
.status-pill.is-clickable:hover {
  filter: brightness(0.95);
}
.is-fullwidth {
  width: 100%;
}

.rent-edit-link {
  color: inherit;
  cursor: pointer;
  border-bottom: 1px dashed #b5b5b5;
}

.rent-edit-link:hover {
  color: #131627;
}
</style>

<style>
.price_filter {
  margin-bottom: 0.5rem;
}
@media screen and (max-width: 768px) {
  /* Toolbar stack: 16px between the search bar, the status row and the
     sort control; the sort control shares the search bar's side margins */
  .data-table-data-wrapper > .card > .mb-2 {
    padding: 16px 20px 0 !important;
    border-bottom: 0 !important;
    margin-bottom: 0 !important;
  }
  .data-table-data-wrapper > .card > .mb-2 > .field {
    margin-bottom: 16px !important;
  }
  .b-table .table-mobile-sort {
    padding: 16px 20px;
  }
  .b-table .table-mobile-sort .field {
    margin-bottom: 0;
  }
  /* Same left/right edges for every toolbar block (search had mr-2) */
  .data-table-data-wrapper > .card > .mb-2 > .field.mr-2 {
    margin-right: 0 !important;
  }
  .filters_container .active_filter label {
    font-size: 15px;
  }
  /* Status select and the Filtres button share one row, select grows */
  .filters_container {
    flex-direction: row;
    align-items: center;
    gap: 10px;
  }
  .filters_container > .w-full {
    flex: 1 1 auto;
    min-width: 0;
    margin-right: 0 !important;
    margin-bottom: 0 !important;
  }
  .filters_container > .w-full .select,
  .filters_container > .w-full select {
    width: 100%;
  }
  .filters_container .filters-row {
    flex: 0 0 auto;
  }
  .filters_container .long_filter label {
    font-size: 15px;
  }
  .filters_container .long_filter {
    padding-top: 0;
  }
  .price_filter {
    margin-bottom: 0 !important;
  }
}
.is-30 {
  width: 26px;
  height: 26px;
}
/* Rent agents facepile: overlapping avatars + grey "+N" bubble */
.agent-pile {
  display: flex;
  align-items: center;
}
.agent-pile > span {
  margin-left: -8px;
}
.agent-pile .b-tooltip {
  display: block; /* no inline baseline gap under the avatar */
}
.agent-pile > span:first-child {
  margin-left: 0;
}
.agent-pile .is-avatar,
.agent-pile .agent-more {
  border: 2px solid #fff;
  box-shadow: 0 0 0 1px #e8e8e8;
  border-radius: 50%;
  display: block;
}
.agent-more {
  background: #d5d5d5;
  color: #4a4a4a;
  font-size: 10px;
  font-weight: 700;
  line-height: 22px;
  text-align: center;
  cursor: default;
}
.agent-empty {
  font-size: 14px;
  color: #7a7a7a;
}
.agent-pile.is-editable,
.agent-pile.is-editable .is-avatar,
.agent-pile.is-editable .agent-more {
  cursor: pointer;
}
.agent-pile.is-editable:hover .is-avatar,
.agent-pile.is-editable:hover .agent-more {
  box-shadow: 0 0 0 2px #2e3d6e;
}
/* "…" actions menu (appended to body, so unscoped): keep each item on one line */
.dropdown-menu .dropdown-item .icon-text {
  flex-wrap: nowrap;
  white-space: nowrap;
}
/* Certificat bon état badge (Devloc certified): blue "certified" seal */
.cert-badge {
  cursor: default;
}
.cert-badge .mdi {
  color: #2563eb;
}

/* Toolbar: switch + Filtres on one row, Filtres always at the right */
.filters-row {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  flex: 1 1 auto;
}
.filters-row > :last-child {
  margin-left: auto;
}
/* Both cells center their content: the popup wrapper is otherwise a block
   taller than its button, which sat higher than the switch on mobile */
.filters-row > div,
.filters-row .active_filter {
  display: flex;
  align-items: center;
}
.filters-row .active_filter .control-label {
  white-space: nowrap;
}
.gap-5 {
  gap: 5px;
}

.rent-edit-link {
  color: inherit;
  cursor: pointer;
  border-bottom: 1px dashed #b5b5b5;
}

.rent-edit-link:hover {
  color: #131627;
}
</style>
